import { END } from 'redux-saga';
import { wrapper, SagaStore } from 'store';
import { REVALIDATE_SECONDS } from '@utils/isr';
import { GET_SEO, GET_TRANSLATE } from '@containers/Home/slice';
import { GetStaticProps } from 'next';
import { PHASE_PRODUCTION_BUILD } from 'next/constants';
import { GET_POLICY } from '@containers/Policy/slice';
import { selectPolicyLocales } from '@containers/Policy/selectors';
import { DEFAULT_LANGUAGE_SELECTED } from 'type';
import PageSeo from '@components/PageSeo';
import dynamic from 'next/dynamic';
const Policy = dynamic(() => import('containers/Policy'), {
  loading: () => <span>Loading...</span>,
});

function PublicContainer() {
  return (
    <>
      <PageSeo />
      <Policy />
    </>
  );
}
export const getStaticProps: GetStaticProps = wrapper.getStaticProps(
  store =>
    async ({ locale, locales }) => {
      store.dispatch(
        GET_SEO({
          locale,
          url: `page/data-page?SiteCode=SunParadiseLand&page=chinh-sach`,
        }),
      );
      store.dispatch(GET_POLICY({ locale, locales }));
      store.dispatch(GET_TRANSLATE({ locale }));
      store.dispatch(END);
      await (store as SagaStore).sagaTask?.toPromise();

      // Next.js cấm trả redirect khi prerender lúc build; trang build sẵn
      // sẽ được Header chuyển về vi ở client, lần revalidate sau mới redirect.
      if (
        process.env.NEXT_PHASE !== PHASE_PRODUCTION_BUILD &&
        locale !== DEFAULT_LANGUAGE_SELECTED &&
        !selectPolicyLocales(store.getState()).includes(locale)
      ) {
        return {
          redirect: { destination: '/chinh-sach', permanent: false },
          revalidate: REVALIDATE_SECONDS,
        };
      }

      return {
        props: {},
        revalidate: REVALIDATE_SECONDS,
      };
    },
);
export default PublicContainer;
